module.exports = __webpack_public_path__ + "img/sv52.83ea89fc.svg";